import { render } from "./page_setup.vue?vue&type=template&id=62f7c825&scoped=true"
import script from "./page_setup.vue?vue&type=script&lang=js"
export * from "./page_setup.vue?vue&type=script&lang=js"

import "./page_setup.vue?vue&type=style&index=0&id=62f7c825&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f7c825"]])

export default __exports__